import { Spin } from 'antd';
import { Outlet } from 'react-router-dom';
import { useFetchMe } from '../hooks/use-fetch-me';
import { useAuthStore } from '../store/auth.store';

export function SessionGate() {
  useFetchMe();

  const isLoadingMe = useAuthStore((s) => s.isLoadingMe);

  if (isLoadingMe) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
        <div role="status" style={{ display: 'grid', justifyItems: 'center', gap: 12 }}>
          <Spin size="large" />
          <span>Verificando sesión...</span>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
